"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _utils = require("../utils");
var useHighlight = function useHighlight(_ref, _ref2) {
  var start = _ref.start,
    end = _ref.end;
  var isSameItem = _ref2.isSameItem;
  var highlightInterval = (0, _react.useMemo)(function () {
    if (!start) {
      return null;
    }
    return {
      start: (0, _utils.min)([start, end]),
      end: (0, _utils.max)([start, end])
    };
  }, [start, end]);
  var handleIsHighlight = (0, _react.useCallback)(function (day) {
    return highlightInterval ? (0, _utils.isWithinInterval)(day, highlightInterval) : false;
  }, [highlightInterval]);
  var handleIsFirstHighlight = (0, _react.useCallback)(function (day) {
    return highlightInterval ? isSameItem(day, highlightInterval.start) : false;
  }, [highlightInterval, isSameItem]);
  var handleIsLastHighlight = (0, _react.useCallback)(function (day) {
    return highlightInterval ? isSameItem(day, highlightInterval.end) : false;
  }, [highlightInterval, isSameItem]);
  return {
    isHighlight: handleIsHighlight,
    isFirstHighlight: handleIsFirstHighlight,
    isLastHighlight: handleIsLastHighlight
  };
};
var _default = exports["default"] = useHighlight;